<template>
    <div class="col-12 mb-primary">
        <div class="card card-with-shadow border-0 h-100">
            <div class="card-header p-primary bg-transparent">
                <h5 class="card-title m-0">{{ $t('update_office') }}</h5>
            </div>
            <app-overlay-loader v-if="preloader"/>
            <div class="card-body">
                 <form ref="form" :data-url='`/office/update/${officedata.id}`' class="mb-0" :class="{'loading-opacity': preloader}" enctype="multipart">
                    
                  <div class="form-group row align-items-center">
                      <label class="col-md-2 mb-md-0">
                          {{ $t('name') }}
                      </label>
                      <app-input class="col-md-8"
                                 type="text"
                                 v-model="officedata.name"
                                 :required="true"
                                 :placeholder="$t('name')"/>
                  </div>
                  <div class="form-group row align-items-center">
                      <label for="email_input" class="col-sm-2 mb-sm-0">
                          {{ $t('email') }}
                      </label>
                      <app-input id="email_input"
                                 class="col-sm-8"
                                 v-model="officedata.email"
                                 type="email"
                                 :placeholder="$t('email_type_input')"/>
                  </div>
                  <div class="form-group row align-items-center">
                      <label class="col-md-2 mb-md-0">
                          {{ $t('mobile_no') }}
                      </label>
                      <app-input class="col-md-8"
                                 type="text"
                                 v-model="officedata.mobile_no"
                                 :required="false"
                                 :placeholder="$t('number_type_input')"/>
                  </div>
                  <div class="form-group row align-items-center">
                      <label for="number_input" class="col-sm-2 mb-sm-0">
                          {{ $t('order_on') }}
                      </label>
                      <app-input id="number_input"
                                 class="col-sm-8"
                                 type="number"
                                 v-model="officedata.order_on"
                                 :placeholder="$t('number_type_input')"/>
                  </div>
                  <div class="form-group row align-items-center">
                      <label class="col-md-2 mb-md-0">
                          {{ $t('address') }}
                      </label>
                      <app-input class="col-md-8"
                                 type="text"
                                 v-model="officedata.address"
                                 :required="false"
                                 :placeholder="$t('address_name')"/>
                  </div>
                  <div class="form-group row align-items-center">
                      <label class="col-md-2 mb-md-0">
                          {{ $t('address1') }}
                      </label>
                      <app-input class="col-md-8"
                                 type="text"
                                 v-model="officedata.address1"
                                 :required="false"
                                 :placeholder="$t('address_name')"/>
                  </div>
                  <div class="form-group row">
                      <label for="inputs_editor" class="col-sm-2 h-fit-content">
                          {{ $t('content') }}
                      </label>
                      <div class="col-sm-8">
                          <app-input type="text-editor"
                                     :required="false"
                                     id="text-editor-id"
                                     :label="$t('message_placeholder')" v-model="officedata.description"/>
                      </div>
                  </div>
                  <div class="form-group row mb-0">
                      <label class="col-sm-2 mb-sm-0">
                          {{ $t('upload_image') }}
                      </label>
                      <div class="col-sm-4">
                          <app-input type="custom-file-upload"
                                     :label="$t('upload_your_file')"
                                     v-model="reqData.featured_image"/>
                      </div>
                      <div class="custom-image-upload-wrapper" v-if="officedata.featured_image">
                            <app-avatar :title="$t('avatars')" class="image-area d-flex" :img="officedata.featured_image"
                                  :alt-text="$t('not_found')"/>         
                        </div>
                  </div>

                  <div class="form-group row align-items-center">
                      <label class="col-md-2 mb-md-0">
                          {{ $t('status') }}
                      </label>
                          <app-input class="col-md-8 mt-2 pt-1"
                                     type="radio"
                                     :list="statusLists"
                                     v-model="officedata.status"
                                     :required="true"/>
                  </div>
                    <div class="mt-5 action-buttons">
                        <button type="submit" class="btn btn-primary mr-2" @click.prevent="submit">
                            {{ $t('submit')}}
                        </button>
                        <button type="submit" class="btn btn-secondary" @click.prevent="clear">
                            {{ $t('clear') }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import {axiosPost} from "../../../../Helpers/AxiosHelper";  
    import {FormMixin} from "../../../../../core/mixins/form/FormMixin"; 
    import * as actions from '../../../../Config/ApiUrl';
    export default {
        name: "UpdateCMS",
        mixins: [FormMixin],
        props: ['officedata'],
        data(){
          return {
            reqData: {}, 
            preloader: false,                
                statusLists: [
                    {id: 'active', value: "Active"},
                    {id: 'inactive', value: "Inactive"},
                ]
          }
        },
        methods: {
            beforeSubmit(){
                this.preloader = true;
            },
            submit() {
                let formData = new FormData;
                for (const [key, value] of Object.entries(this.officedata)) {
                    if (value != null) formData.append(key, value);
                }

                if (this.reqData.featured_image) {
                    formData.append("featured_image", this.reqData.featured_image);
                }
                this.save(formData);
            },
            afterSuccess(res) {
                this.$toastr.s(res.data.message);
                window.location.reload();
            },
            afterFinalResponse() {
                this.preloader = false;
            },
            afterError(res) {
                this.$toastr.e(res.data.message);
            },
            clear() {
                this.fieldStatus = {
                    isSubmit: false
                }
            },
        }
    }
</script>